import React from 'react'
import '../assests/members.css'

function Members({data}) {
  
  return (
    <div className="members">
      <div className="members-heading">
        <h1>
          SGC {" "}
          <span style={{ color: "#32BAC7" }}>
            Members
          </span>
        </h1>
      </div>
      <div className="members-head">
      {
        data.map((items) => (
          <div className="members-details" key={items.id}>
            <img className="member-image" src={items.link} alt={items.name}>
            </img>
            <p>
              {items.name}
            </p>
            <p>
              {items.position}
            </p>
          </div>
        ))
      }
      </div>
    </div>
  )
}

export default Members